export const can = (permissions, action, module) => {
  if (!permissions || typeof permissions !== "object") return false;

  // module ko lowercase + trim karo for consistent matching
  const normalizedModule = String(module).toLowerCase().trim();

  // action ko canRead / canWrite / canDelete format mein convert karo
  const actionMap = {
    read:   "canRead",
    write:  "canWrite",
    delete: "canDelete",  
  };

  const permKey = actionMap[String(action).toLowerCase()] ?? `can${String(action).charAt(0).toUpperCase()}${String(action).slice(1)}`;

  // permissions object mein module dhundo (case-insensitive key match)
  const moduleKey = Object.keys(permissions).find(
    (k) => k.toLowerCase() === normalizedModule
  );
  
  if (!moduleKey) return false;

  return permissions[moduleKey][permKey] === true;
};
